import { useQuery } from '@tanstack/react-query'

import { errorToast } from 'common/components/toastNotification'

import { fetchMetabaseDashboardUrl } from '../api'
import { reportsKeys } from '../queryKeys/reportsKeys'

const useGetMetabaseDashboardUrlQuery = (
  dashboardId: string | undefined,
  accountId: string | undefined
) => {
  return useQuery({
    queryKey: reportsKeys.metabaseDashboardUrl(
      dashboardId ?? '',
      accountId ?? ''
    ),
    queryFn: () => fetchMetabaseDashboardUrl(dashboardId!, accountId!),
    enabled: !!dashboardId && !!accountId,
    staleTime: 10 * 60 * 1000,
  })
}

export default useGetMetabaseDashboardUrlQuery
